module.exports = __webpack_public_path__ + "img/logo-sfi@2x.png";